import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45abe2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column pa-4 ga-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center pa-2"
}
const _hoisted_3 = {
  class: "d-flex flex-column ga-2",
  style: {"width":"600px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Functional Location", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-right"
}
const _hoisted_6 = {
  key: 0,
  class: "text-right"
}

import { FunctionalLocation, PlannerGroup, CostCenter } from "@/classes";
import { Deleteable, FLOCBoundary } from "@/classes/asset-management-plan";

import RichText from "@/components/base/inputs/RichText.vue";
import { computed, onMounted, ref } from "vue";
import { useAMPStore } from "@/store/asset-management-plan";
import FLOCSearch from "../FLOCSearch.vue";
import FunctionalLocationTree from "@/components/functional-location/tree/FunctionalLocationTree.vue";
import { TreeItem } from "@/components/functional-location/tree/tree";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeBoundaryLimits',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

const flocs = ref<FunctionalLocation[]>([]);
const searchCostCenters = ref<CostCenter[]>([]);
const searchPlanners = ref<PlannerGroup[]>([]);

const plannerGroups = ref<PlannerGroup[]>([]);
const costCenters = ref<CostCenter[]>([]);

const flocTree = ref<InstanceType<typeof FunctionalLocationTree> | null>(null);
const flocDialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(
  null,
);
const treeItems = ref<TreeItem<FunctionalLocation>[]>([]);

// Display tree items in same order as boundary list
const sortedTreeItems = computed(() => {
  const items: TreeItem<FunctionalLocation>[] = [];
  store.plan.floc_boundaries.forEach((bound) => {
    const item = treeItems.value.find(
      (i) => i.item.id === bound.functional_location_id,
    );
    if (item) items.push(item);
  });
  return items;
});

onMounted(() => {
  fetchPlannerGroups();
  fetchCostCenters();
  refreshTreeItems();
});

const refreshTreeItems = async () => {
  const flocIds: string[] = [];
  for (const bound of store.plan.floc_boundaries) {
    const exist = treeItems.value.find(
      (item) => item.item.id === bound.functional_location_id,
    );
    if (!exist) flocIds.push(bound.functional_location_id);
  }
  const flocs = await FunctionalLocation.getTreeChildren({
    parent_id: null,
    floc_ids: flocIds,
  });
  for (const floc of flocs) {
    const item = {
      item: floc,
      expanded: false,
      children: null,
    } as TreeItem<FunctionalLocation>;
    treeItems.value.push(item);
  }
};

const fetchingPlannerGroups = ref(false);
const fetchPlannerGroups = async () => {
  fetchingPlannerGroups.value = true;
  plannerGroups.value = await PlannerGroup.filters(
    {
      cost_center_ids: searchCostCenters.value.map((c) => c.id),
    },
    "functional-location/planner-group",
  );
  fetchingPlannerGroups.value = false;
};

const fetchingCostCenters = ref(false);
const fetchCostCenters = async () => {
  fetchingCostCenters.value = true;
  costCenters.value = await CostCenter.filters(
    {
      planner_group_ids: searchPlanners.value.map((p) => p.id),
    },
    "functional-location/cost-center",
  );
  fetchingCostCenters.value = false;
};

const addBoundaries = () => {
  flocs.value.forEach((floc) => {
    const boundary = new FLOCBoundary();
    boundary.asset_management_plan = store.plan;
    boundary.asset_management_plan_id = store.plan.id;
    boundary.functional_location = floc;
    boundary.functional_location_id = floc.id;
    store.plan.floc_boundaries.push(boundary);
  });
  flocs.value = [];
  refreshTreeItems();
  store.getPreventativeMaintenance();
};

const deleteBoundary = (boundary: FLOCBoundary) => {
  store.plan.floc_boundaries = store.plan.floc_boundaries.filter(
    (b) => b.id !== boundary.id,
  );
  treeItems.value = treeItems.value.filter(
    (item) => item.item.id !== boundary.functional_location_id,
  );
  store.getPreventativeMaintenance();
  emit("delete", boundary);
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.context_general_information,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.context_general_information) = $event)),
      label: "3.1 Context & General Information",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(_component_v_card, {
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("3.2 Boundary Limits")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.readonly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_autocomplete, {
                  label: "Cost Center",
                  modelValue: searchCostCenters.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((searchCostCenters).value = $event)),
                    fetchPlannerGroups
                  ],
                  items: costCenters.value,
                  clearable: true,
                  loading: fetchingCostCenters.value,
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  "item-value": "id",
                  "item-title": "name",
                  multiple: "",
                  "return-object": ""
                }, null, 8, ["modelValue", "items", "loading"]),
                _createVNode(_component_v_autocomplete, {
                  label: "Planner Group",
                  modelValue: searchPlanners.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((searchPlanners).value = $event)),
                    fetchCostCenters
                  ],
                  items: plannerGroups.value,
                  clearable: true,
                  loading: fetchingPlannerGroups.value,
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  "item-value": "id",
                  "item-title": "name",
                  multiple: "",
                  "return-object": ""
                }, null, 8, ["modelValue", "items", "loading"]),
                _createVNode(FLOCSearch, {
                  label: "Functional Location",
                  modelValue: flocs.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((flocs).value = $event)),
                  flocs: 
              _unref(store).plan.floc_boundaries.map((b) => b.functional_location)
            ,
                  "cost-centers": searchCostCenters.value,
                  "planner-groups": searchPlanners.value,
                  clearable: "",
                  variant: "outlined",
                  multiple: "",
                  density: "compact",
                  "hide-details": ""
                }, null, 8, ["modelValue", "flocs", "cost-centers", "planner-groups"])
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                disabled: flocs.value.length === 0,
                color: "primary",
                class: "mt-2 mb-2",
                variant: "text",
                onClick: addBoundaries
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-plus")
                    ]),
                    _: 1
                  }),
                  _createTextVNode("Add ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_table, {
          "fixed-header": "",
          density: "compact",
          class: "boundary-limits-table"
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                (!_ctx.readonly)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_5, "Action"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plan.floc_boundaries, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.functional_location.functional_location), 1),
                  (!_ctx.readonly)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                        _createVNode(_component_v_btn, {
                          icon: "mdi-delete",
                          color: "red",
                          variant: "plain",
                          onClick: ($event: any) => (deleteBoundary(item))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("3.3 Boundary Limits Tree")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(FunctionalLocationTree, {
          ref_key: "flocTree",
          ref: flocTree,
          "tree-items": sortedTreeItems.value,
          "max-height": "500px",
          onView: _cache[4] || (_cache[4] = ($event: any) => (flocDialog.value?.open($event.item.id)))
        }, null, 8, ["tree-items"]),
        _createVNode(FunctionalLocationDialog, {
          ref_key: "flocDialog",
          ref: flocDialog,
          readonly: ""
        }, null, 512)
      ]),
      _: 1
    })
  ]))
}
}

})